import React, { useState, useEffect } from 'react';
import { Search, Plus, Edit, Trash2, CheckCircle, Clock, AlertCircle, ArrowUpDown, X, DollarSign, Package } from 'lucide-react';

const FixedAssets = ({ user }) => {
  const [assets, setAssets] = useState([]);
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilter, setActiveFilter] = useState('all');
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('add'); // 'add', 'edit'
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [sortField, setSortField] = useState('created_date');
  const [sortDirection, setSortDirection] = useState('desc');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);

  

  const [formData, setFormData] = useState({
    name: '',
    asset: '',
    serialnum: '',
    location: '',
    manufacture: '',
    model: '',
    notes: '',
    ponum: '',
    cost: ''
  });

  // Counts state
  const [counts, setCounts] = useState({
    draft: 0,
    biomed: 0, // Same as draft - assets needing biomed submission
    pending_purchase: 0,
    complete: 0,
    total: 0
  });

  // Fetch assets
  const fetchAssets = async () => {
    setLoading(true);
    try {
      console.log('=== FETCHING ASSETS ===');
      console.log('activeFilter:', activeFilter);
      
      // Map "biomed" filter to "draft" status since they're the same
      const statusFilter = activeFilter === 'biomed' ? 'draft' : activeFilter;
      console.log('statusFilter being sent to API:', statusFilter);
      
      const response = await fetch(`/api/fixed-assets?status=${statusFilter}`);
      const data = await response.json();
      
      console.log('API Response:', data);
      console.log('Number of assets received:', data.data?.length || 0);
      
      setAssets(data.data || []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching assets:', error);
      setLoading(false);
      setAssets([]);
    }
  };

  // Fetch counts
  const fetchCounts = async () => {
    try {
      console.log('=== FETCHING COUNTS ===');
      const response = await fetch('/api/fixed-assets/counts');
      const data = await response.json();
      console.log('Counts received:', data);
      setCounts(data);
    } catch (error) {
      console.error('Error fetching counts:', error);
    }
  };

  // Filter and sort assets
  const filterAndSortAssets = () => {
    let filtered = [...assets];

    // Apply search filter
    if (searchTerm) {
      filtered = filtered.filter(asset =>
        asset.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        asset.asset?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        asset.location?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        asset.manufacture?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        asset.model?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        asset.ponum?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Apply sorting
    filtered.sort((a, b) => {
      let aVal = a[sortField] || '';
      let bVal = b[sortField] || '';
      
      if (sortField === 'created_date') {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      }
      
      if (sortDirection === 'asc') {
        return aVal > bVal ? 1 : -1;
      } else {
        return aVal < bVal ? 1 : -1;
      }
    });

    setFilteredAssets(filtered);
    setCurrentPage(1);
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      name: '',
      asset: '',
      serialnum: '',
      location: '',
      manufacture: '',
      model: '',
      notes: '',
      ponum: '',
      cost: ''
    });
    setSelectedAsset(null);
  };

  // Open modal
  const openModal = (mode, asset = null) => {
    setModalMode(mode);
    if (mode === 'edit' && asset) {
      setSelectedAsset(asset);
      setFormData({
        name: asset.name || '',
        asset: asset.asset || '',
        serialnum: asset.serialnum || '',
        location: asset.location || '',
        manufacture: asset.manufacture || '',
        model: asset.model || '',
        notes: asset.notes || '',
        ponum: asset.ponum || '',
        cost: asset.cost || ''
      });
    } else {
      resetForm();
    }
    setShowModal(true);
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    resetForm();
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const payload = {
        ...formData,
        userId: user.id,
        userName: user.fullName
      };

      const url = modalMode === 'add' ? '/api/fixed-assets' : `/api/fixed-assets/${selectedAsset.id}`;
      const method = modalMode === 'add' ? 'POST' : 'PUT';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (result.success) {
        closeModal();
        await Promise.all([fetchAssets(), fetchCounts()]);
      } else {
        alert('Error: ' + result.error);
      }
    } catch (error) {
      console.error('Submit error:', error);
      alert('Error: ' + error.message);
    }
  };

  // Change status
  // Change status
const changeStatus = async (assetId, newStatus) => {
  console.log('=== CHANGE STATUS DEBUG ===');
  console.log('Asset ID:', assetId);
  console.log('New Status:', newStatus);
  console.log('User:', user);

  if (!window.confirm(`Change status to ${newStatus.replace('_', ' ')}?`)) {
    return;
  }

  try {
    const response = await fetch(`/api/fixed-assets/${assetId}/status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        status: newStatus,
        userId: user.id,
        userName: user.fullName
      })
    });

    console.log('Response status:', response.status);
    const result = await response.json();
    console.log('Response data:', result);

    if (result.success) {
      console.log('Status change successful, refreshing data...');
      await Promise.all([fetchAssets(), fetchCounts()]);
    } else {
      alert('Error: ' + result.error);
    }
  } catch (error) {
    console.error('Status change error:', error);
    alert('Error: ' + error.message);
  }
};

  // Delete asset
  const deleteAsset = async (assetId) => {
    if (!window.confirm('Are you sure you want to delete this asset?')) {
      return;
    }

    try {
      const response = await fetch(`/api/fixed-assets/${assetId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: user.id,
          userName: user.fullName
        })
      });

      const result = await response.json();

      if (result.success) {
        await Promise.all([fetchAssets(), fetchCounts()]);
      } else {
        alert('Error: ' + result.error);
      }
    } catch (error) {
      console.error('Delete error:', error);
      alert('Error: ' + error.message);
    }
  };

  // useEffect hooks
  useEffect(() => {
    fetchCounts();
    fetchAssets();
  }, [activeFilter]);

  useEffect(() => {
    filterAndSortAssets();
  }, [assets, searchTerm, sortField, sortDirection]);

  // Helper functions
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'draft': return <AlertCircle className="w-4 h-4 text-gray-500" />;
      case 'pending_purchase': return <Clock className="w-4 h-4 text-blue-500" />;
      case 'complete': return <CheckCircle className="w-4 h-4 text-green-500" />;
      default: return <AlertCircle className="w-4 h-4 text-gray-400" />;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'draft': return 'bg-gray-100 text-gray-800';
      case 'pending_purchase': return 'bg-blue-100 text-blue-800';
      case 'complete': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'draft': return 'Draft';
      case 'pending_purchase': return 'Purchasing Department';
      case 'complete': return 'Complete';
      default: return 'Unknown';
    }
  };

  const canEdit = (asset) => {
  // New role-based permissions
  if (user.user_role === 'asset_manager') return true;
  if (user.user_role === 'pm_user') return true;
  if (user.user_role === 'admin') return true;
  
  // Legacy permissions for backward compatibility
  if (user.isAdmin === 'Y') return true;
  if (user.canView === '1') return true;
  if (user.role === 'admin') return true;
  if (user.role === 'biomed' && asset.complete === 'draft') return true;
  if (user.role === 'purchasing' && asset.complete === 'pending_purchase') return true;
  
  return false;
};

const canChangeStatus = (asset, newStatus) => {
  // Don't show "Mark Complete" button if already complete
  if (newStatus === 'complete' && asset.complete === 'YES') {
    return false;
  }
  
  // Don't show "Submit to Purchase" if already submitted
  if (newStatus === 'pending_purchase' && asset.complete === 'pending_purchase') {
    return false;
  }
  
  // New role-based permissions
  if (user.user_role === 'asset_manager') return true;
  if (user.user_role === 'pm_user') return true;
  if (user.user_role === 'admin') return true;
  
  // Legacy permissions for backward compatibility
  if (user.isAdmin === 'Y') return true;
  if (user.canView === '1') return true;
  if (user.role === 'admin') return true;
  if (user.role === 'biomed' && asset.complete === 'draft' && newStatus === 'pending_purchase') return true;
  if (user.role === 'purchasing' && asset.complete === 'pending_purchase' && newStatus === 'complete') return true;
  
  return false;
};


  // Pagination
  const totalPages = Math.ceil(filteredAssets.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentAssets = filteredAssets.slice(startIndex, endIndex);

  // Status filters
  const filters = [
    { key: 'all', label: 'All Assets', count: counts.total },
    { key: 'biomed', label: 'Biomed', count: counts.draft, icon: Package }, // Assets needing submission to purchasing
    { key: 'pending_purchase', label: 'Purchasing Department', count: counts.pending_purchase, icon: DollarSign }, // Renamed from "Pending Purchase"
    { key: 'complete', label: 'Complete', count: counts.complete, icon: CheckCircle }
  ];

  return (
    <div style={{ padding: '1.5rem' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h1 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '0.5rem' }}>NRMC Fixed Assets</h1>
          <p style={{ color: '#6b7280' }}>Manage fixed asset lifecycle - Use the "Biomed" tab to submit assets to purchasing</p>
        </div>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          {(user.user_role === 'asset_manager' || user.user_role === 'pm_user' || user.user_role === 'admin' || 
  user.isAdmin === 'Y' || user.canView === '1' || user.role === 'biomed' || user.role === 'admin') && (
            <button
              onClick={() => openModal('add')}
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', background: '#2563eb', color: 'white', border: 'none', borderRadius: '0.375rem', cursor: 'pointer' }}
            >
              <Plus size={16} />
              Add Asset
            </button>
          )}
        </div>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        {filters.map(filter => {
          const IconComponent = filter.icon;
          return (
            <button
              key={filter.key}
              onClick={() => setActiveFilter(filter.key)}
              style={{
                padding: '0.5rem 1rem',
                borderRadius: '0.375rem',
                border: '1px solid #d1d5db',
                background: activeFilter === filter.key ? '#2563eb' : 'white',
                color: activeFilter === filter.key ? 'white' : '#374151',
                cursor: 'pointer',
                fontSize: '0.875rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              {IconComponent && <IconComponent size={16} />}
              {filter.label}
              <span style={{
                background: activeFilter === filter.key ? 'rgba(255,255,255,0.2)' : '#e5e7eb',
                padding: '0.125rem 0.375rem',
                borderRadius: '0.25rem',
                fontSize: '0.75rem',
                fontWeight: '600'
              }}>
                {filter.count}
              </span>
            </button>
          );
        })}
      </div>

      {/* Search */}
      <div style={{ marginBottom: '1.5rem' }}>
        <div style={{ position: 'relative', maxWidth: '400px' }}>
          <Search size={20} style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }} />
          <input
            type="text"
            placeholder="Search assets, locations, manufacturers..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '0.75rem 0.75rem 0.75rem 2.5rem',
              border: '1px solid #d1d5db',
              borderRadius: '0.375rem',
              fontSize: '0.875rem'
            }}
          />
        </div>
      </div>

      {/* Results count */}
      <div style={{ marginBottom: '1rem', color: '#6b7280', fontSize: '0.875rem' }}>
        Showing {currentAssets.length} of {filteredAssets.length} assets
      </div>

      {/* Table */}
      <div style={{ background: 'white', borderRadius: '0.5rem', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', fontSize: '0.875rem' }}>
            <thead style={{ background: '#f9fafb' }}>
              <tr>
                <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600' }}>
                  <button
                    onClick={() => handleSort('status')}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', background: 'none', border: 'none', cursor: 'pointer', fontWeight: '600' }}
                  >
                    Status <ArrowUpDown size={14} />
                  </button>
                </th>
                <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600' }}>
                  <button
                    onClick={() => handleSort('name')}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', background: 'none', border: 'none', cursor: 'pointer', fontWeight: '600' }}
                  >
                    Device Name <ArrowUpDown size={14} />
                  </button>
                </th>
                <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600' }}>
                  <button
                    onClick={() => handleSort('asset')}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', background: 'none', border: 'none', cursor: 'pointer', fontWeight: '600' }}
                  >
                    Asset Tag <ArrowUpDown size={14} />
                  </button>
                </th>
                <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600' }}>Equipment Details</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600' }}>
                  <button
                    onClick={() => handleSort('location')}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', background: 'none', border: 'none', cursor: 'pointer', fontWeight: '600' }}
                  >
                    Location <ArrowUpDown size={14} />
                  </button>
                </th>
                <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600' }}>Purchase Info</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" style={{ padding: '2rem', textAlign: 'center', color: '#6b7280' }}>
                    Loading assets...
                  </td>
                </tr>
              ) : currentAssets.length === 0 ? (
                <tr>
                  <td colSpan="7" style={{ padding: '2rem', textAlign: 'center', color: '#6b7280' }}>
                    No assets found matching your criteria
                  </td>
                </tr>
              ) : (
                currentAssets.map(asset => (
                  <tr key={asset.id} style={{ borderTop: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '0.75rem' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        {getStatusIcon(asset.complete)}
                        <span style={{
                          padding: '0.25rem 0.5rem',
                          borderRadius: '0.25rem',
                          fontSize: '0.75rem',
                          fontWeight: '500'
                        }} className={getStatusColor(asset.complete)}>
                          {getStatusText(asset.complete)}
                        </span>
                      </div>
                    </td>
                    <td style={{ padding: '0.75rem' }}>
                      <div style={{ fontWeight: '500' }}>{asset.name}</div>
                      {asset.notes && (
                        <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.25rem' }}>{asset.notes}</div>
                      )}
                    </td>
                    <td style={{ padding: '0.75rem' }}>
                      <div style={{ fontWeight: '500', color: '#2563eb' }}>{asset.asset}</div>
                      {asset.serialnum && (
                        <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>S/N: {asset.serialnum}</div>
                      )}
                    </td>
                    <td style={{ padding: '0.75rem' }}>
                      <div style={{ fontWeight: '500' }}>{asset.manufacture}</div>
                      {asset.model && (
                        <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>{asset.model}</div>
                      )}
                    </td>
                    <td style={{ padding: '0.75rem' }}>
                      <div>{asset.location}</div>
                    </td>
                    <td style={{ padding: '0.75rem' }}>
                      {asset.ponum && (
                        <div style={{ fontSize: '0.75rem' }}>
                          <div>PO: {asset.ponum}</div>
                          {asset.cost && <div>Cost: ${parseFloat(asset.cost).toFixed(2)}</div>}
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '0.75rem' }}>
                      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                        {canEdit(asset) && (
                          <button
                            onClick={() => openModal('edit', asset)}
                            style={{ padding: '0.25rem 0.5rem', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '0.25rem', fontSize: '0.75rem', cursor: 'pointer' }}
                          >
                            <Edit size={12} />
                          </button>
                        )}
                        
                        {/* Status transition buttons */}
                        {canChangeStatus(asset, 'pending_purchase') && (
                          <button
                            onClick={() => changeStatus(asset.id, 'pending_purchase')}
                            style={{ padding: '0.25rem 0.5rem', background: '#2563eb', color: 'white', border: 'none', borderRadius: '0.25rem', fontSize: '0.75rem', cursor: 'pointer' }}
                          >
                            Submit to Purchase
                          </button>
                        )}
                        
                        {canChangeStatus(asset, 'complete') && (
                          <button
                            onClick={() => changeStatus(asset.id, 'complete')}
                            style={{ padding: '0.25rem 0.5rem', background: '#16a34a', color: 'white', border: 'none', borderRadius: '0.25rem', fontSize: '0.75rem', cursor: 'pointer' }}
                          >
                            Mark Complete
                          </button>
                        )}
                        
                        {(user.user_role === 'asset_manager' || user.user_role === 'pm_user' || user.user_role === 'admin' || 
                            user.isAdmin === 'Y' || user.canView === '1' || user.role === 'admin') && (
                          <button
                            onClick={() => deleteAsset(asset.id)}
                            style={{ padding: '0.25rem 0.5rem', background: '#dc2626', color: 'white', border: 'none', borderRadius: '0.25rem', fontSize: '0.75rem', cursor: 'pointer' }}
                          >
                            <Trash2 size={12} />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div style={{ padding: '1rem', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
              Page {currentPage} of {totalPages}
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button
                onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
                style={{
                  padding: '0.5rem 0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '0.375rem',
                  background: 'white',
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  opacity: currentPage === 1 ? 0.5 : 1
                }}
              >
                Previous
              </button>
              <button
                onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                disabled={currentPage === totalPages}
                style={{
                  padding: '0.5rem 0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '0.375rem',
                  background: 'white',
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                  opacity: currentPage === totalPages ? 0.5 : 1
                }}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: '0.5rem', padding: '2rem', maxWidth: '600px', width: '90vw', maxHeight: '90vh', overflow: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
              <h3 style={{ fontSize: '1.5rem', fontWeight: '600' }}>
                {modalMode === 'add' ? 'Add New Asset' : 'Edit Asset'}
              </h3>
              <button onClick={closeModal} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                <X size={24} />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Device Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Asset Tag *</label>
                  <input
                    type="text"
                    name="asset"
                    value={formData.asset}
                    onChange={handleInputChange}
                    required
                    style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem' }}
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Serial Number</label>
                  <input
                    type="text"
                    name="serialnum"
                    value={formData.serialnum}
                    onChange={handleInputChange}
                    style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Location *</label>
                  <input
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    required
                    style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem' }}
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Manufacturer *</label>
                  <input
                    type="text"
                    name="manufacture"
                    value={formData.manufacture}
                    onChange={handleInputChange}
                    required
                    style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Model</label>
                  <input
                    type="text"
                    name="model"
                    value={formData.model}
                    onChange={handleInputChange}
                    style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem' }}
                  />
                </div>
              </div>

             {(user.user_role === 'asset_manager' || user.user_role === 'pm_user' || user.user_role === 'admin' || 
                  user.isAdmin === 'Y' || user.canView === '1' || user.role === 'purchasing' || user.role === 'admin') && (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                    <div>
                      <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>PO Number</label>
                      <input
                        type="text"
                        name="ponum"
                        value={formData.ponum}
                        onChange={handleInputChange}
                        style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Cost</label>
                      <input
                        type="number"
                        step="0.01"
                        name="cost"
                        value={formData.cost}
                        onChange={handleInputChange}
                        style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem' }}
                      />
                    </div>
                  </div>
                )}

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Notes</label>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleInputChange}
                  rows="3"
                  style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', resize: 'vertical' }}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <button
                  type="button"
                  onClick={closeModal}
                  style={{ padding: '0.5rem 1rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', background: 'white', cursor: 'pointer' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{ padding: '0.5rem 1rem', background: '#2563eb', color: 'white', border: 'none', borderRadius: '0.375rem', cursor: 'pointer' }}
                >
                  {modalMode === 'add' ? 'Add Asset' : 'Update Asset'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default FixedAssets;